<template>
  <div>
    <top-navbar></top-navbar>

    <div class="mb-5 background_color">
      <h6 class="manage-boder pt-2 font1 decoration">
        <router-link class="decoration" to="/"> Home </router-link
        ><span class="pfimg3"
          ><i class="fa fa-angle-right" aria-hidden="true"></i></span
        ><a class="decoration">Employee </a
        ><span class="pfimg3"
          ><i class="fa fa-angle-right" aria-hidden="true"></i
        ></span>
        Fuel Report
      </h6>
      <!-- <h6 class="custom-maintitle mb-2"><b>Create Customer </b></h6> -->
      <div style="padding-bottom: 100px" class="container-fluid">

 <b-modal id="payModal" size="lg" title="Payment Details" @show="loadPaymentData">
      <!-- Table -->
      <b-table    
      style="font-size: small;"
                class="table-hover" 
                :items="paymentRows" :fields="fields2"
                 head-variant="dark"
                 small >
        <template #cell(amount)="data">
          <div class="text-right">{{ data.item.amount }}</div>
        </template>
      </b-table>

      <!-- Total -->
      <div class="text-right font-weight-bold my-2">
        Total: {{ totalAmount.toFixed(2) }}
      </div>

      <!-- Note -->
      <b-form-group label="Note">
        <b-form-textarea v-model="paymentNote" rows="3" placeholder="Enter your payment note here..." />
      </b-form-group>

      <!-- File Upload -->
      <b-form-group label="Upload File">
      <input
            type="file"
            @change="handleFileUpload"
            class="form-control bdr-rad font-size_def"
          />
      </b-form-group>

      <template #modal-footer>
        <button class="btn btn-sm btn-outline-primary  mb-1 mt-0 bdr-rad" @click="submitPayment">Submit Bill</button>
        <button class="btn btn-sm btn-outline-secondary bdr-rad" @click="$bvModal.hide('payModal')">Close</button>
      </template>
    </b-modal>

        <div

          style="border: 0px; padding: 0px; min-height: 0px"
          class="navbar background_color"
        >
          <div class="d-flex">
            <b-input-group size="sm" style="width: 225px">
              <b-form-input
                id="filter-input"
                class="bdr-rad"
                v-model="filter"
                type="search"
                placeholder="Search"
                @input="loadMiinventory()"
              >
              </b-form-input>
            </b-input-group>
            <div style="margin-top: 11px" class="ms-2">
              <span class="custom-breadcrumb"
                ><b>Showing {{ totalRows }} items.</b></span
              >
            </div>
          </div>

          <div class="d-grid gap-2 d-md-flex justify-content-md-end"></div>
        </div>

        <div  class="card bdr-rad2 mt-1 shadow p-2">
          <div class="card-body">
            <div>
              <div  class="table-responsive">
                <b-table
                 responsive
                style="font-size: small;"
                class="table-hover"
                :items="all_data"
                :fields="fields"
                :current-page="currentPage"
                head-variant="dark"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
                    :sort-direction="sortDirection"
                    show-empty
                  small
                >
                >

                <template #cell(number)="row">
                 <!-- {{ row.index + 1 === 10 ? currentPage * 10 : (currentPage - 1)*10 + row.index + 1 }} -->
                  <input v-show="row.item.statusvalue==10" type="checkbox" v-model="selectedRows" :value="row.item.id">
                  </template>
                    <template #cell(url)="row">
         <img :src="row.item.file_url" alt="Image" width="100" />
                  </template>
                   <template #cell(action)="row">
        <div class="dropdown">
        <button class="btn btn-sm btn-outline-primary dropdown-toggle bdr-rad" type="button" data-toggle="dropdown" aria-expanded="false">
          Action
        </button>
        <div class="dropdown-menu bdr-rad">
          <a class="dropdown-item mouse-cursor" @click="Viewpage(row.item.id)">View</a>
       
           <a class="dropdown-item mouse-cursor" v-if="row.item.statusvalue==1 && row.item.role_id==15"  @click="Approved(row.item.id)">Approved</a>
           
        

        </div>
      </div>

      </template>
                </b-table>

                      <!-- <b-col style="padding-left: 0px;" sm="7" md="2" class="my-1 mb-4">
                  <b-pagination v-model="currentPage"  @input="pageChanged"   pills :total-rows="totalRows" :per-page="perPage" size="sm"></b-pagination>
                </b-col> -->
              </div>
            </div>
            <div class="text-end">
              <button @click="openModal"  class="btn btn-sm btn-outline-primary  mb-1 mt-0 bdr-rad">  Pay</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- <vue-select label="value" style="z-index: 999;" v-model="selectedOption" :options="options" ></vue-select> <br><br><br><br><br><br> -->
    <content-footer></content-footer>
  </div>
</template>
    <script>
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import axios from "axios";
import authService from "@/auth.service";
import TopNavbar from "./../../layout/TopNavbar.vue";
import ContentFooter from "./../../layout/ContentFooter.vue";
import Table from '@/components/Table.vue'

export default {
  mounted() {
    this.loadMiinventory();
  },
  data() {
    return {
      access_token: authService.isLoggedIn(),
      userid: authService.isUserid(),
      table1: false,

       sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
        FromDate: null,
        ToDate: null,
      filterOn: [],
      totalRows:1,
       currentPage: 1,

      perPage:10,
      pageOptions: [5, 10, 15, { value: 100, text: "Show a lot" }],

      file: null,
      // alldata:{
      //   'keyword':'',
      // },

      alldata: {},

      filter: null,

      filterOn: [],
      users: [],
      mcustomers: [],
      totalRows: 0,

      all_data: [],

            selectedRows: [], // <-- Pass your selected IDs to this before opening
      paymentRows: [],
      paymentNote: '',
      paymentFile: '',
      totalAmount: 0,
      fields2: [
        { key: 'index', label: '#' },
        { key: 'salesman', label: 'Salesman Name' },
        { key: 'vehicle', label: 'Vehicle Number' },
        { key: 'date', label: 'Date' },
        { key: 'amount', label: 'Amount', class: 'text-right' }
      ],


      fields: [
        { key: "number", label: "#", sortable: true },
        { key: "sales_name", label: "Salesman Name", sortable: true },
        { key: "vehicle_num", label: "Vehicle Number", sortable: true },
        { key: "fuel_amount", label: "Amount", sortable: true },
        { key: "url", label: "File", sortable: true },
        { key: "created_date", label: "Date", sortable: true },
        { key: "status", label: "Status", sortable: true },
        { key: "action", label: "Action", sortable: true },
      ],
    };
  },
  components: {
    "v-select": vSelect,
    ContentFooter,
    TopNavbar,
  	Table,
	},

  computed: {},

  methods: {

      handleFileUpload(event) {
    this.paymentFile = event.target.files[0]; // Get the first selected file
  },

     openModal() {
      if (this.selectedRows.length === 0) {
        alert('No rows selected.');
        return;
      }
      this.$bvModal.show('payModal');
    },

     loadPaymentData() {
  this.paymentRows = [];
  this.totalAmount = 0;

  axios.post('/mproduct/paymentdatafuel', {
    ids: this.selectedRows
  })
  .then(response => {
    if (response.data.success) {
      const responseData = response.data.data;

      // console.log(responseData);

      this.paymentRows = responseData.map((item, index) => ({
        index: index + 1,
        ...item
      }));

      this.totalAmount = this.paymentRows.reduce((sum, item) => {
        return sum + parseFloat(item.amount.replace(/,/g, ''));
      }, 0);
    } else {
      alert(response.data.message || 'Failed to fetch payment data.');
    }
  })
  .catch(error => {
    console.error('Error loading payment data:', error);
    alert('Server error while loading payment data.');
  });
},

  submitPayment() {
  const formData = new FormData();
  formData.append('note', this.paymentNote);
  formData.append('file', this.paymentFile);
  formData.append("userid", JSON.stringify(this.userid));
  formData.append('ids', JSON.stringify(this.selectedRows));

  axios.post('/mproduct/submitpaymentfuel', formData)
    .then(response => {
      const res = response.data;
      console.log(res);

      if (res.success) {
        alert('✅ ' + res.message || 'Payment submitted successfully!');
         this.loadMiinventory();
        this.$bvModal.hide('payModal');

        // Optional: clear form fields
        this.paymentNote = '';
        this.paymentFile = null;
        this.selectedRows = [];
      } else {
        alert('❌ Error: ' + (res.message || 'Something went wrong.'));
      }
    })
    .catch(error => {
      console.error('Submission error:', error);
      alert('❌ Server error. Please try again.');
    });
},

  

     pageChanged(newPage) {
      if (newPage !== this.previousPage) {
        console.log("Page changed to:", newPage);
        this.previousPage = newPage; // Update previous page tracker
        this.loadMiinventory(newPage);
      }
    },
    async Createtimesheet() {
      this.$router.push("/timesheet/create");
    },

    downloadExcel() {
      if (!this.all_data.length) {
        alert("No data to export!");
        return;
      }

      const exportColumns = [
        { key: "day", label: "Day" },
        { key: "date", label: "Date" },
        { key: "comment", label: "Comment" },
        { key: "from", label: "From" },
        { key: "to", label: "To" },
        { key: "hours", label: "Hours" },
      ];

      const headers = exportColumns.map((col) => col.label);
      const dataRows = this.all_data.map((row) =>
        exportColumns.map((col) => row[col.key])
      );

      const worksheet = XLSX.utils.aoa_to_sheet([]);

      // Title
      XLSX.utils.sheet_add_aoa(worksheet, [["Timesheet Report"]], {
        origin: "A1",
      });
      worksheet["!merges"] = [
        {
          s: { r: 0, c: 0 },
          e: { r: 0, c: headers.length - 1 },
        },
      ];
      worksheet["A1"].s = {
        font: { bold: true, sz: 14 },
        alignment: { horizontal: "center" },
      };

      // Add header
      XLSX.utils.sheet_add_aoa(worksheet, [headers], { origin: "A2" });

      // Add data
      XLSX.utils.sheet_add_aoa(worksheet, dataRows, { origin: "A3" });

      // Style column headers (Row 2)
      for (let i = 0; i < headers.length; i++) {
        const cellAddress = XLSX.utils.encode_cell({ r: 1, c: i });
        worksheet[cellAddress].s = {
          font: { bold: true, color: { rgb: "FFFFFF" } },
          fill: {
            patternType: "solid",
            fgColor: { rgb: "00B0F0" }, // Aqua blue background
          },
          alignment: { horizontal: "center" },
          border: {
            top: { style: "thin", color: { rgb: "000000" } },
            bottom: { style: "thin", color: { rgb: "000000" } },
            left: { style: "thin", color: { rgb: "000000" } },
            right: { style: "thin", color: { rgb: "000000" } },
          },
        };
      }

      worksheet["!cols"] = headers.map(() => ({ wch: 15 }));

      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Timesheet");

      const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
        cellStyles: true,
      });

      const blob = new Blob([excelBuffer], {
        type: "application/octet-stream",
      });

      saveAs(blob, "Timesheet_Data.xlsx");
    },

     async loadCustomer() {
      try {
        const { data } = await axios.get(
          "/mcustomer/customerload",
          {
            headers: {
              Authorization: "Bearer " + this.access_token,
              "Content-type": "application/json",
            },
          }
        );
        console.log(data);
        this.mcustomers = data.customers;
        this.users = data.users;
      } catch (error) {
        console.log(error.response);
      }
    },

    async Approved(id) {
      try {
        const { data } = await axios.get(
          "/mproduct/approved?id="+id,
          {
            headers: {
              Authorization: "Bearer " + this.access_token,
              "Content-type": "application/json",
            },
          }
        );
        console.log(data);
       if(data.status=200){
        this.loadMiinventory();
       }
      } catch (error) {
        console.log(error.response);
      }
    },

    async loadMiinventory(page = this.currentPage) {
      try {
        console.log(page);
        const { data } = await axios.get(
          "/mproduct/indexfuel?id="+this.userid,

          {
            params: {
            page: page,
            perPage: this.perPage,
            filter: this.filter,
            FromDate: this.FromDate,
            ToDate: this.ToDate,
          },
            headers: {
              Authorization: "Bearer " + this.access_token,
              "Content-type": "application/json",
            },
          }
        );
        console.log(data);

         this.all_data = data.all_data;
        this.totalRows = data.total_count;
        this.currentPage = data.page;




        // this.isLoading = false;
      } catch (error) {
        console.log(error.response);
      }
    },
  },
};
</script>

    <style scoped>
.vs__dropdown-toggle {
  border-radius: 10px !important;
  border-top-left-radius: 10px !important;
  border-top-right-radius: 10px !important;
  border-bottom-right-radius: 10px !important;
}
</style>
